/**
 * 40 kit designer swatches (reference palette). Values are lowercase hex.
 */

export const KIT_COLOR_SWATCHES = [
  { name: 'White', value: '#ffffff' },
  { name: 'Light gray', value: '#cccccc' },
  { name: 'Dark gray', value: '#666666' },
  { name: 'Black', value: '#000000' },
  { name: 'Pale blue', value: '#b3e5fc' },
  { name: 'Sky blue', value: '#4fc3f7' },
  { name: 'Steel blue', value: '#1e88e5' },
  { name: 'Navy blue', value: '#0d47a1' },
  { name: 'Midnight blue', value: '#001033' },
  { name: 'Cyan blue', value: '#03a9f4' },
  { name: 'Teal', value: '#4db6ac' },
  { name: 'Light teal', value: '#80cbc4' },
  { name: 'Forest green', value: '#1b5e20' },
  { name: 'Medium green', value: '#43a047' },
  { name: 'Grass green', value: '#4caf50' },
  { name: 'Lime green', value: '#8bc34a' },
  { name: 'Maroon', value: '#7f1d1d' },
  { name: 'Deep red', value: '#d32f2f' },
  { name: 'Bright red', value: '#f44336' },
  { name: 'Orange red', value: '#ff5722' },
  { name: 'Vibrant orange', value: '#ff9800' },
  { name: 'Golden yellow', value: '#ffb300' },
  { name: 'Warm yellow', value: '#fdd835' },
  { name: 'Lemon yellow', value: '#ffff00' },
  { name: 'Deep purple', value: '#4a148c' },
  { name: 'Royal purple', value: '#7b1fa2' },
  { name: 'Medium purple', value: '#9c27b0' },
  { name: 'Lavender', value: '#ce93d8' },
  { name: 'Burgundy', value: '#691a33' },
  { name: 'Plum', value: '#ad1457' },
  { name: 'Magenta', value: '#d81b60' },
  { name: 'Hot pink', value: '#e91e63' },
  { name: 'Rose pink', value: '#f06292' },
  { name: 'Coral', value: '#e57373' },
  { name: 'Blush pink', value: '#f8bbd0' },
  { name: 'Pale peach', value: '#ffebee' },
  { name: 'Chocolate', value: '#4e342e' },
  { name: 'Brown', value: '#6d4c41' },
  { name: 'Tan', value: '#a1887f' },
  { name: 'Cream', value: '#fff9c4' },
];

/** Hex (lowercase) -> display name */
export const KIT_COLOR_NAMES = KIT_COLOR_SWATCHES.reduce((acc, { name, value }) => {
  acc[value] = name;
  return acc;
}, {});

export function normalizeHex(hex) {
  if (!hex || typeof hex !== 'string') return '';
  let h = hex.trim().toLowerCase();
  if (h.startsWith('#') && h.length === 4) {
    h = `#${h[1]}${h[1]}${h[2]}${h[2]}${h[3]}${h[3]}`;
  }
  return h;
}

export function getKitColorName(hex, fallback = 'Custom') {
  const n = normalizeHex(hex);
  return KIT_COLOR_NAMES[n] || fallback;
}

/** Check icon contrast on swatch */
export function isLightSwatchHex(hex) {
  const n = normalizeHex(hex).replace('#', '');
  if (n.length !== 6) return false;
  const r = parseInt(n.slice(0, 2), 16);
  const g = parseInt(n.slice(2, 4), 16);
  const b = parseInt(n.slice(4, 6), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.72;
}
